import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { AttachFile } from "@mui/icons-material";
import { Chip } from "@mui/material";
import {
	ColDef,
	EditableCallbackParams,
	ICellRendererParams,
} from "ag-grid-enterprise";

const MarkdownCellRenderer = (params: ICellRendererParams) => {
	if (!params.value) return null;

	const html = params.value
		.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
		.replace(/\*(.+?)\*/g, "<em>$1</em>")
		.replace(/`(.+?)`/g, "<code>$1</code>")
		.replace(/\n/g, "<br/>");

	return <span dangerouslySetInnerHTML={{ __html: html }} />;
};

export const useTableData = () => {
	const columnDefs: ColDef[] = [
		{
			field: "CreateTimestamp",
			headerName: "Created",
			flex: 1,
			valueGetter: (params) =>
				dxtToLocalServerTime(params.data.CreateTimestamp, "MM/dd/yy HH:mm"),
		},

		{
			field: "Title",
			headerName: "Title",
			flex: 2,
		},
		{
			field: "Author",
			headerName: "Created By",
			flex: 1,
		},
		{
			field: "Content",
			headerName: "Content",
			flex: 5,
			cellStyle: {
				justifyContent: "flex-start",
			},
			wrapText: true,
			autoHeight: true,
			cellRenderer: MarkdownCellRenderer,
		},
		{
			field: "AttachmentCount",
			headerName: "",
			flex: 1,
			headerComponent: () => (
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						height: "100%",
						width: "100%",
						textAlign: "center",
					}}
				>
					<AttachFile style={{ fontSize: 18, color: "#666" }} />
				</div>
			),
			cellRenderer: (params: EditableCallbackParams) => {
				const count = params.data.AttachmentCount || 0;
				if (count === 0) {
					return null;
				}
				return (
					<div
						style={{
							display: "flex",
							alignItems: "center",
							height: "100%",
							justifyContent: "center",
						}}
					>
						<Chip
							icon={<AttachFile style={{ fontSize: 16 }} />}
							label={count}
							size="small"
							variant="outlined"
							color="primary"
						/>
					</div>
				);
			},
		},
	];
	return { columnDefs };
};
